// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1egnS","requiredAsterisk":"Info_requiredAsterisk__SEXPj"};